import { useQuery } from 'react-query';
import { PurchaseSpedListRequest } from './purchase-sped.types';
import purchaseSpedServices from './purchase-sped.services';

const QUERY_PURCHASE_SPED_LIST = 'purchase-sped/list';

export function usePurchaseSpedList(
  params: PurchaseSpedListRequest,
  enabled = true,
) {
  return useQuery({
    queryKey: [QUERY_PURCHASE_SPED_LIST],
    queryFn: () => purchaseSpedServices.list(params),
    enabled: !!params.companyId && !!params.month && !!params.year && enabled,
  });
}
